interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  image: string;
  imageAlt: string;
  eyebrowSize?: string;
  titleSize?: string;
}

export default function PageHeader({
  eyebrow,
  title,
  subtitle,
  image,
  imageAlt,
  eyebrowSize = "text-xs",
  titleSize = "text-3xl md:text-5xl lg:text-6xl",
}: PageHeaderProps) {
  return (
    <section className="relative h-[420px] md:h-[520px] w-full overflow-hidden">
      <img src={image} alt={imageAlt} className="absolute inset-0 w-full h-full object-cover object-center" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>
      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-4 pt-16">
        <div className={`inline-flex items-center gap-2 mb-5 px-4 py-1.5 rounded-full border border-background-50/40 text-background-50 ${eyebrowSize} tracking-[0.3em] uppercase backdrop-blur-sm`}>
          {eyebrow}
        </div>
        <h1 className={`font-heading text-background-50 ${titleSize} font-medium max-w-3xl leading-[1.1] tracking-tight`}>
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-background-100 text-base md:text-xl font-light max-w-2xl whitespace-pre-line">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}